<template>
  <div>
    <span>商戶內充:</span>
    <el-button type="primary" @click="go">前往</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mid: ""
    };
  },
  methods: {
    getCollection() {
      this.$http.get(`/back/collection/deposit`).then(res => {
        this.mid = res.data.data;
      });
    },
    go() {
      window.open(`${process.env.VUE_APP_DEFAULT_CTC}home?mid=${this.mid}`);
    }
  },
  created() {
    this.getCollection();
  }
};
</script>
